import "./Section2.scss";

// assets
// import gameplayVideoThumbnail_img from "../../../assets/pages/Home/gameplay-video-thumbnail.jpg";
// import playButton_img from "../../../assets/pages/Home/play-button.svg";
// import playButtonInner_img from "../../../assets/pages/Home/play-button-inner.svg";
import "animate.css";
// code imports
import React from 'react';
import { Link } from "react-router-dom";
import Reveal from "../../common/UI_Elements/Reveal";
import VideoShowcase from "./VideoShowcase";
import LogoMarquee from "../../common/UI_Elements/LogoMarquee";
import InTheNews from "./InTheNews";
import OurBlogs from "./OurBlogs";



function AsSeenOn() {
    return (
        <Reveal className="AsSeenOn col-12">
            <h2 className="SectionHeading text-center w-100 text-white"
                style={{ fontWeight: 'bold', marginTop: "34px" }}>
                AS SEEN ON
            </h2>
            <LogoMarquee />
        </Reveal>
    );
}

function Section2({ style }) {
    const styles = {
        backgroundColor: 'rgb(26, 6, 47)',
        ...style
    };

    return (
        <div className="HomePage-Section2 row d-flex justify-content-center pt-0 pb-5" style={styles}>
            <VideoShowcase />

            {/* Pavilion banner (full width, sits right above the creators banner) */}
            {/* <Reveal className="PavilionBanner col-12 px-0">
                <a target="_blank" rel="noopener noreferrer" href="https://pavilion.hitwicket.com/login">
                    <img
                        src="https://cdn.octathorpeweb.com/v1/website/sachinxhw/webstore_banner_v1.png"
                        alt="Save more on purchases with Hitwicket Pavilion"
                    />
                </a>
            </Reveal> */}

            {/* Backed by cricket legends */}
            <Reveal className="LegendsBanner col-12 px-0">
                <picture>
                    <source media="(max-width: 767px)" srcSet="https://cdn.octathorpeweb.com/v1/website/sachinxhw/sachin_harsha_mobile.png" width="436" height="301" />
                    <img
                        src="https://cdn.octathorpeweb.com/v1/website/sachinxhw/sachin_harsha.jpg"
                        width="1279" height="884"
                        alt="Backed by cricket legends: Sachin Tendulkar and Harsha Bhogle"
                    />
                </picture>
                {/* The same copy that is painted into the image, as real text for search engines and screen readers */}
                <div className="seo-hidden">
                    <h2>Backed by Cricket Legends</h2>
                    <h3>Sachin Tendulkar</h3>
                    <p>
                        Sachin Tendulkar, an icon whose legacy defines generations of cricket, joins Hitwicket as our
                        Brand Ambassador and Investor, bringing his belief to our growth journey.
                    </p>
                    <h3>Harsha Bhogle</h3>
                    <p>
                        Harsha Bhogle brings his unmatched storytelling and cricket insights to Hitwicket as our
                        Strategic Investor, backing our vision of taking cricket gaming to new heights.
                    </p>
                </div>
            </Reveal>

            {/* News section */}
            <InTheNews />

            <AsSeenOn />
            {/* Content creators banner */}
            <Reveal className="CreatorsBanner col-12 px-0">
                <Link to="/creator-program" target="_blank" rel="noopener noreferrer" className="d-block">
                    <picture>
                        <source media="(max-width: 767px)" srcSet="https://cdn.octathorpeweb.com/v1/website/sachinxhw/content_creator_mobile.png" width="436" height="218" />
                        <img
                            src="https://cdn.octathorpeweb.com/v1/website/sachinxhw/content_creator_v2.webp"
                            width="1024" height="512"
                            alt="Join our Creators Club"
                        />
                    </picture>
                </Link>
            </Reveal>

            {/* Latest blog posts, pulled live from hitwicket.com/worldcup/blogs */}
            <OurBlogs />
        </div>
    );
}


export default Section2;


